import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import { testimonials } from '@/mocks/comics';

const breadcrumbItems = [
  { label: '首页', href: '/' },
  { label: '关于我们' },
];

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于漫蛙漫画网',
  description: '漫蛙漫画网是一个免费漫画在线阅读平台，提供海量韩漫、日漫、国漫资源。了解我们的品牌故事、用户评价和联系方式。',
  url: 'https://manwacomics.com/about',
  mainEntity: {
    '@type': 'Organization',
    name: '漫蛙漫画网',
    description: '免费韩漫日漫国漫在线阅读平台',
    url: 'https://manwacomics.com',
  },
};

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg data={aboutSchema} />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <div className="max-w-7xl mx-auto px-4 md:px-6 pb-8">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              关于我们
            </h1>
            <p className="mt-2 text-sm text-foreground-500">
              了解漫蛙漫画的品牌故事与发展历程
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
          <section className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">品牌故事</span>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mt-2">
                让每个人都能享受漫画的乐趣
              </h2>
              <div className="mt-5 space-y-4 text-sm text-foreground-600 leading-relaxed">
                <p>
                  漫蛙漫画网成立于2023年，是一个专注于免费漫画在线阅读的平台。我们的使命是让每一个漫画爱好者都能方便、快捷地获取到优质的漫画资源。
                </p>
                <p>
                  平台收录了海量韩漫、日漫、国漫作品，涵盖热血、爱情、玄幻、校园、奇幻等多种题材。所有漫画资源均支持高清在线阅读，无需下载APP，打开浏览器即可畅享阅读体验。
                </p>
                <p>
                  我们与国内外多家漫画平台建立了深度合作关系，确保漫画资源的持续更新。热门连载作品通常在原版发布后24小时内完成同步更新。
                </p>
                <p>
                  漫蛙漫画始终坚持"免费、高清、快速"的服务理念，为千万漫画爱好者提供优质的阅读服务。未来，我们将继续拓展漫画资源库，优化阅读体验，让漫画阅读变得更加简单和愉快。
                </p>
              </div>
              <div className="mt-6 grid grid-cols-3 gap-6">
                <div className="text-center p-3 rounded-lg bg-primary-50">
                  <p className="text-xl font-bold text-primary-600">10,000+</p>
                  <p className="text-xs text-foreground-500 mt-1">漫画资源</p>
                </div>
                <div className="text-center p-3 rounded-lg bg-accent-50">
                  <p className="text-xl font-bold text-accent-600">3大</p>
                  <p className="text-xs text-foreground-500 mt-1">漫画分类</p>
                </div>
                <div className="text-center p-3 rounded-lg bg-secondary-50">
                  <p className="text-xl font-bold text-secondary-600">24小时</p>
                  <p className="text-xs text-foreground-500 mt-1">同步更新</p>
                </div>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden h-80 lg:h-96">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20cozy%20reading%20space%20with%20warm%20coral%20and%20cream%20tones%2C%20bookshelves%20with%20comic%20books%2C%20soft%20natural%20lighting%20through%20window%2C%20comfortable%20reading%20nook%2C%20minimalist%20interior%20design%2C%20artistic%20manga%20posters%20on%20wall%2C%20warm%20inviting%20atmosphere%2C%20professional%20photography&width=800&height=600&seq=about-brand-image&orientation=landscape"
                alt="漫蛙漫画 - 品牌故事"
                title="漫蛙漫画网 - 让阅读成为一种享受"
                className="w-full h-full object-cover"
              />
            </div>
          </section>

          <section className="mt-16">
            <div className="text-center mb-10">
              <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider">用户口碑</span>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mt-2">
                听听漫画迷们怎么说
              </h2>
              <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
                来自真实用户的好评，是漫蛙持续前进的动力
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((t, i) => (
                <div key={i} className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: t.rating }).map((_, idx) => (
                      <i key={idx} className="ri-star-fill text-accent-400 text-sm" />
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">"{t.comment}"</p>
                  <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/70">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        title={`${t.name} - 用户评价`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <span className="text-sm font-semibold text-foreground-800">{t.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mt-16">
            <div className="text-center mb-10">
              <span className="text-xs font-semibold text-secondary-600 uppercase tracking-wider">联系我们</span>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mt-2">
                有任何问题？联系我们
              </h2>
              <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
                欢迎通过以下方式与我们取得联系
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-3xl mx-auto">
              <div className="p-6 rounded-xl bg-background-100 text-center border border-background-200/70">
                <div className="w-12 h-12 mx-auto rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-600" />
                </div>
                <h3 className="mt-4 text-sm font-semibold text-foreground-800">电子邮箱</h3>
                <p className="mt-1 text-xs text-foreground-500">contact@manwacomics.com</p>
              </div>
              <div className="p-6 rounded-xl bg-background-100 text-center border border-background-200/70">
                <div className="w-12 h-12 mx-auto rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-xl text-accent-600" />
                </div>
                <h3 className="mt-4 text-sm font-semibold text-foreground-800">微信公众号</h3>
                <p className="mt-1 text-xs text-foreground-500">漫蛙漫画</p>
              </div>
              <div className="p-6 rounded-xl bg-background-100 text-center border border-background-200/70">
                <div className="w-12 h-12 mx-auto rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-question-answer-line text-xl text-secondary-600" />
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-800">在线反馈</h3>
                <p className="mt-1 text-xs text-foreground-500">通过表单提交问题</p>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}